import { render, staticRenderFns } from "./TableVisitStatus.vue?vue&type=template&id=00407e4f"
import script from "./TableVisitStatus.vue?vue&type=script&lang=js"
export * from "./TableVisitStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports